import React from 'react';
import { Helmet } from 'react-helmet-async';
import Link from '@components/shared/Link';
import { useAppContext } from '@/context/AppContext';

/**
 * Not Found Page - app/not-found.js
 * Handles 404 errors - click anywhere to go home
 */
function NotFound() {
    const { setStatus } = useAppContext();

    // Effects never run during SSR, so the server learns the status here.
    if (typeof window === 'undefined' && setStatus) setStatus(404);

    React.useEffect(() => {
        if (setStatus) {
            setStatus(404);
        }
    }, [setStatus]);

    return (
        <Link 
            to="/"
            className="fixed inset-0 w-full h-full flex items-center justify-center bg-background z-[99999] cursor-pointer no-underline"
            aria-label="Click to go to home page"
            data-not-found="true"
        >
            <Helmet title="404" />
            <span 
                className="text-[30vw] leading-none text-black select-none font-bold font-sansumi"
            >
                404
            </span>
        </Link>
    );
}

export default NotFound;
